module.exports = __webpack_public_path__ + "media/images/about_solution-pic6-d77fe139.png";